import { api } from "./client";

const OVERVIEW_PATH = "/api/transaction-reports/overview";
const ALL_USERS_PATH = "/api/transaction-reports/all-users";

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

export const getPosOverviewReport = async (params = {}) => {
  const token = localStorage.getItem("token");
  const lang = localStorage.getItem("lang") || "en";

  const { data } = await api.get(OVERVIEW_PATH, {
    params: cleanParams(params),
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "Accept-Language": lang,
    },
  });

  return data;
};

export const getAllUsersPosReport = async (params = {}) => {
  const token = localStorage.getItem("token");
  const lang = localStorage.getItem("lang") || "en";

  const { data } = await api.get(ALL_USERS_PATH, {
    params: cleanParams(params),
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "Accept-Language": lang,
    },
  });

  return data;
};
